
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/sora-2-pro",
      function () {
        return require("private-next-pages/models/sora-2-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/sora-2-pro"])
      });
    }
  